<script setup lang="ts">
import { computed } from 'vue';
import { RouterLink } from 'vue-router';

import { useError } from '../../composables/useError';

const { error } = useError();

/**
 * Maps internal error state to Nuxt UI UError component props.
 * - error.title -> error.statusMessage (displayed as main heading)
 * - error.description -> error.message (displayed as subtext)
 */
const errorProps = computed(() => {
  if (!error.value) {
    return null;
  }

  return {
    statusCode: error.value.statusCode,
    statusMessage: error.value.title,
    message: error.value.description,
  };
});

const isCritical = computed(() => error.value?.critical === true);

const handleReload = () => {
  window.location.reload();
};
</script>

<template>
  <UError
    v-if="errorProps"
    :error="errorProps"
    :clear="false"
    data-testid="u-error"
  >
    <template #links>
      <!-- Critical error: reload page -->
      <UButton
        v-if="isCritical"
        size="lg"
        color="primary"
        label="Reload page"
        @click="handleReload"
      />
      <!-- Non-critical error: back to home -->
      <!-- Error is cleared by beforeEach error middleware when navigation starts -->
      <UButton
        v-else
        :as="RouterLink"
        to="/"
        size="lg"
        color="primary"
        label="Go to home"
      />
    </template>
  </UError>
</template>
